import type { Node, Schema } from '@atlaskit/editor-prosemirror/model';
import { AiMateMarkdownTransformer } from '@atlassian/conversation-assistant-content-transformer';
import { RegexStorage } from '@atlassian/conversation-assistant-content-transformer/dist/types/common/utils/content-transformer/linking-platform/utils';
import {
	FindFilepathsFn,
	IsLinkInMatchesFn,
} from '@atlassian/conversation-assistant-content-transformer/dist/types/common/utils/content-transformer/md-tokenizer/md-plugin-linkify';

import groupedCitation from './plugins/grouped-citation-plugin';

type PluginConfig = {
	linkify: {
		findFilepaths: FindFilepathsFn;
		isLinkInMatches: IsLinkInMatchesFn;
	};
	smartLinks: {
		regexStorage: RegexStorage;
	};
};

export default class AiSummaryAdfEncoder extends AiMateMarkdownTransformer {
	public constructor(schema: Schema, pluginConfig: PluginConfig, streaming?: boolean) {
		super(schema, pluginConfig, streaming);

		const tokenizer = this.parser.tokenizer;
		// Override the default citation plugin to handle citations to allow grouping consecutive citations into one citation node.
		tokenizer.use(groupedCitation);
	}

	public override parse(content: string): Node {
		return super.parse(content);
	}
}
